module.exports = __webpack_public_path__ + "static/media/cifar.dc766dca.jpg";